module.exports = __webpack_public_path__ + "static/media/0263_Medium.d0216637.jpg";